import createIcon from '../../createIcon';

/**
 * @component @name Streetview
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNTYgMTUuMzNDMTEuMjIgMTUuNiAxMSAxNi4wMyAxMSAxNi41VjIySDE4QzE5LjEgMjIgMjAgMjEuMSAyMCAyMFYxNC4wMkMxOS4wNiAxMy42OSAxOC4wNSAxMy41IDE3IDEzLjVDMTQuOTcgMTMuNSAxMy4wNyAxNC4yIDExLjU2IDE1LjMzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3IDEyQzE5Ljc2MTQgMTIgMjIgOS43NjE0MiAyMiA3QzIyIDQuMjM4NTggMTkuNzYxNCAyIDE3IDJDMTQuMjM4NiAyIDEyIDQuMjM4NTggMTIgN0MxMiA5Ljc2MTQyIDE0LjIzODYgMTIgMTcgMTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAuNSA3QzEwLjUgNS45MiAxMC43NyA0LjkgMTEuMjQgNEg0QzIuOSA0IDIgNC45IDIgNlYyMEMyIDIwLjU1IDIuMjMgMjEuMDUgMi41OSAyMS40MUwxMi40MSAxMS41OUMxMS4yMyAxMC40MiAxMC41IDguOCAxMC41IDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Streetview = createIcon('Streetview', [
  [
    'path',
    {
      d: 'M11.56 15.33C11.22 15.6 11 16.03 11 16.5V22H18C19.1 22 20 21.1 20 20V14.02C19.06 13.69 18.05 13.5 17 13.5C14.97 13.5 13.07 14.2 11.56 15.33Z',
      key: 'yem6wv',
    },
  ],
  [
    'path',
    {
      d: 'M17 12C19.7614 12 22 9.76142 22 7C22 4.23858 19.7614 2 17 2C14.2386 2 12 4.23858 12 7C12 9.76142 14.2386 12 17 12Z',
      key: '1hya3o',
    },
  ],
  [
    'path',
    {
      d: 'M10.5 7C10.5 5.92 10.77 4.9 11.24 4H4C2.9 4 2 4.9 2 6V20C2 20.55 2.23 21.05 2.59 21.41L12.41 11.59C11.23 10.42 10.5 8.8 10.5 7Z',
      key: '1353nk',
    },
  ],
]);

export default Streetview;
